import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import useAuth from 'contexts/AuthContext';

// The student dashboard (Home) sits at APP_DEFAULT_PATH, which is also
// where a fresh login and every guard's "you can't be here" redirect land.
// Instructors have no reason to see it — they have their own portal — so
// this catches both cases in one place rather than teaching every redirect
// call site about roles.
export default function RoleHome({ children }) {
  const { user } = useAuth();
  if (user?.role === 'instructor') return <Navigate to="/instructor" replace />;
  return children;
}

RoleHome.propTypes = { children: PropTypes.node };
